export default "__VITE_ASSET__d8a64028__"